module.exports = __webpack_public_path__ + "pic/58.417fcbe9.png";